const initialState = {
    matchingRuleNames: [],
    matchingRuleNamesForSelectionBox: [],
    mappedProcessingOrders: [],
    unMappedMatchingRules: [],
    unMappedWorkflowRules: [],
};


export default initialState;